import { render, staticRenderFns } from "./AccessCodePrompt.vue?vue&type=template&id=5b4085f7&scoped=true"
import script from "./AccessCodePrompt.vue?vue&type=script&lang=js"
export * from "./AccessCodePrompt.vue?vue&type=script&lang=js"
import style0 from "./AccessCodePrompt.vue?vue&type=style&index=0&id=5b4085f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4085f7",
  null
  
)

export default component.exports